import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Modal from 'react-modal';
import './AdCreateModal.scss';
import { FETCH_ARCHIVE_ACCEPTED } from '../../../redux/ArchiveTables';
import { ACCEPTED } from '../../../consts/navigation';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';
class AdCreateModal extends PureComponent {
  componentDidMount() {
    this.props.fetchArchiveAcceptedOffers();
  }

  render() {
    const { isOpen, closeModal, archiveAcceptedOffers, t, } = this.props;

    Modal.setAppElement('body');

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        isCloseButtonShown={true}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          content: {
            position: 'absolute',
            width: 'calc(100% - 40px)',
            maxWidth: '500px',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '20px',
          },
        }}
        contentLabel="Modal"
        className="make-photos"
      >
        <div className="ad-create-modal">
          <h4>{t('new_ad')}</h4>

          <div className="ad-create-modal__templates-wrapper">
            { archiveAcceptedOffers.map((offer, index) => {
              return <Link key={index} to={`/dashboard/ads/new-ad?accepted_offer_id=${get(offer, 'hash_id')}`}>{get(offer, ['vehicle', 'brand_name'])} {get(offer, ['vehicle', 'model'])}, {get(offer, ['vehicle', 'year'])}</Link>
            })}
          </div>

          <p className="ad-create-modal__link-wrapper">
            ... {t('or')} <Link to="/dashboard/ads/new-ad">{t('new_ad_without_template')}</Link>
          </p>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    archiveAcceptedOffers: get(state, ['archive', ACCEPTED, 'data']),
    totalCount: get(state, ['archive', ACCEPTED, 'total_count']),
    totalPages: get(state, ['archive', ACCEPTED, 'total_pages']),
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchArchiveAcceptedOffers: () => dispatch(FETCH_ARCHIVE_ACCEPTED()),
});

AdCreateModal.propTypes = {
  t: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  fetchArchiveAcceptedOffers: PropTypes.func.isRequired,
  archiveAcceptedOffers: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('breadcrumbs.ads.new_ad_modal')
)(AdCreateModal);
